import { Button, DatePicker } from "antd";
import dayjs, { Dayjs } from "dayjs";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PDFLogo from "../../../assets/images/live_tracking_pdf.svg";
import CustomModal from "../../../components/ui/CustomModal";
import { dbDateFormat } from "../../../constants/constants";
import { useLazyDownloadTrackingHistoryQuery } from "../../../features/tracking/trackingApi";
import { ModalComponentProps } from "../../../types";

const { RangePicker } = DatePicker;

type Props = {
  loading: boolean;
} & ModalComponentProps;

export default function DownloadTrackingModal({ handleClose, ...rest }: Props) {
  const { viewId } = useParams();
  const today = dayjs();
  const last30Days = today.subtract(30, "days");
  const [dates, setDates] = useState<[Dayjs, Dayjs]>([
    dayjs().subtract(1, "month"),
    dayjs(),
  ]);

  // const contentRef = useRef<HTMLDivElement | null>(null);
  // const { generatePdf } = usePdfGenerator();

  // const { user } = useAppSelector((state) => state.auth);
  // const { currentRef, downloadPDF } = usePrint("Tracking_history_report.pdf");
  const [downloadTrackingHistory, { isLoading: isDownloading, data: pdfUrl }] =
    useLazyDownloadTrackingHistoryQuery();

  // const { data, isLoading } = useGetTrackingDataByDateRangeQuery(
  //   {
  //     params: {
  //       business_member_id: Number(viewId),
  //       startDate: dates?.[0]?.format(dbDateFormat),
  //       endDate: dates?.[1]?.format(dbDateFormat),
  //     },
  //   },
  //   {
  //     skip: !viewId,
  //   }
  // );

  // const {
  //   data: businessData,
  //   isError: isBusinessError,
  //   error: businessError,
  // } = useGetBusinessDataQuery(
  //   user?.data?.userData?.business_id?.toString() || "",
  //   {
  //     skip: !user?.data?.userData?.business_id,
  //   }
  // );

  // const {
  //   isError: isEmployeeDetailsError,
  //   error: employeeDetailsError,
  //   data: employeeDetailsData,
  // } = useGetEmployeeDetailsQuery(viewId || "", {
  //   skip: !viewId,
  // });
  // useError(isBusinessError, businessError, "Get business data fail");
  // useError(
  //   isEmployeeDetailsError,
  //   employeeDetailsError,
  //   "Get email details data fail"
  // );

  // Ensure data is structured correctly
  // const dataList = (data as { data?: { date: string }[] }) ?? {};

  // Ensure dataList.data exists and is an array before reducing
  // const groupedData = (
  //   Array.isArray(dataList?.data) ? dataList.data : []
  // ).reduce((acc: Record<string, { date: string; data: any[] }>, item) => {
  //   if (!item?.date) return acc; // Skip if date is missing

  //   acc[item.date] = acc[item.date] || { date: item.date, data: [] };
  //   acc[item.date].data.push(item);

  //   return acc;
  // }, {});

  // Convert grouped object to an array
  // const result = Object.values(groupedData);

  // const firstDate = result[0]?.date;
  // const lastDate = result[result.length - 1]?.date;

  // const convertTimeFormat = (time: string) => {
  //   return dayjs(time, "HH:mm:ss").format("hh:mm A");
  // };

  // const employeeInfo = employeeDetailsData?.data?.employee;

  const disabledDate = (current: dayjs.Dayjs) => {
    return current.isAfter(today, "day") || current.isBefore(last30Days, "day");
  };

  const handleDownloadTrackingHistory = () => {
    downloadTrackingHistory({
      params: {
        business_member_id: Number(viewId),
        startDate: dates?.[0]?.format(dbDateFormat),
        endDate: dates?.[1]?.format(dbDateFormat),
      },
    });
  };

  useEffect(() => {
    // console.log("useEffect", pdfUrl);
    if (pdfUrl) {
      const link = document.createElement("a");
      link.href = pdfUrl;
      link.download = "tracking_history_report.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      handleClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pdfUrl]);

  return (
    <CustomModal {...rest} handleClose={handleClose} footer={null}>
      <div>
        <div className="flex justify-center items-center mt-4 mb-4">
          <img src={PDFLogo} alt="pdf_file_icon" className="w-[80px]" />
        </div>
        <div className="flex justify-center items-center mt-4 mb-4 font-bold text-xl">
          <h4>Download Report</h4>
        </div>
        <div className="flex justify-center items-center mt-2 mb-2 font-normal text-slate-500">
          You can download maximum of past 31 days data.
        </div>
        <div className="flex justify-center items-center mt-4 mb-4">
          <RangePicker
            className="my-2 clear-button-hide"
            value={dates}
            disabledDate={disabledDate}
            onChange={(d) => {
              if (d && d[0] && d[1]) setDates([d[0], d[1]]);
            }}
          />
        </div>{" "}
        <div className="flex flex-col items-center gap-4 mt-4 mb-4">
          <Button
            className="modal-button w-[250px]"
            type="primary"
            htmlType="submit"
            size="middle"
            loading={isDownloading}
            onClick={() => {
              handleDownloadTrackingHistory();
            }}
          >
            Download
          </Button>
          <Button
            className="normal-dark-button modal-button  w-[250px]"
            onClick={handleClose}
            size="middle"
          >
            Close
          </Button>
        </div>
      </div>
    </CustomModal>
  );
}
